import { audio, iframe, newspaper, pdf, video } from '../../../utils/icons';


const Icon = ({ galleryIcon, type }) => {
    let iconClass = "";
    let iconName = "";

    switch (type) {
        case "audio":
            iconClass = "music_icon audio_icon";
            iconName = audio;
            break;
        case "video":
            iconClass = "music_icon video_icon";
            iconName = video;
            break;
        case "content":
            iconClass = "contnet-svgImage";
            iconName = newspaper;
            break;
        case "pdf":
            iconClass = "music_icon video_icon";
            iconName = pdf;
            break;
        default:
            iconClass = "music_icon audio_icon";
            iconName = iframe;
    }

    return galleryIcon && <div className={iconClass}>{iconName}</div>;
}

export default Icon;
